import { syncPersistedUploadJob } from "../redux/slices/transferManagerSlice";
import { updateUpload } from "./uploadSlice";

export function startUploadProgressSync({
  store,
  manager,
  intervalMs = 500
} = {}) {
  if (!store || typeof store.dispatch !== "function") {
    throw new Error(
      "A Redux store is required to synchronize upload progress."
    );
  }
  if (!manager || typeof manager.readIncompleteUploads !== "function") {
    throw new Error("An upload manager is required to synchronize progress.");
  }

  let stopped = false;
  let timer = null;

  async function sync() {
    if (stopped) return;
    try {
      const jobs = await manager.readIncompleteUploads();
      jobs.forEach(job => {
        store.dispatch(updateUpload(job));
        store.dispatch(syncPersistedUploadJob({ job }));
      });
    } catch (error) {
      // A later poll retries transient persistence failures.
    } finally {
      if (!stopped) timer = setTimeout(sync, intervalMs);
    }
  }

  const ready = sync();
  return {
    ready,
    stop() {
      stopped = true;
      if (timer) clearTimeout(timer);
    }
  };
}
